module.exports = __webpack_public_path__ + "img/plan-2-b8.4639434f.png";